import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSonarObjectsUsersSlice } from './get';
import { putCoreSonarObjectsUsersSlice } from './put';

import { coreSonarObjectsUsersBulkReducers, coreSonarObjectsUsersBulkWatchers } from './bulk';

export const coreSonarObjectsUsersReducers = combineReducers({
	bulk: coreSonarObjectsUsersBulkReducers,
	get: getCoreSonarObjectsUsersSlice.asyncReducers,
	put: putCoreSonarObjectsUsersSlice.asyncReducers
});

export const coreSonarObjectsUsersWatchers = combineAllWatchers([
	coreSonarObjectsUsersBulkWatchers,
	getCoreSonarObjectsUsersSlice.asyncWatchers,
	putCoreSonarObjectsUsersSlice.asyncWatchers
]);
